'use strict';

var RomSummaryMaxActMinRevenueViewport = function RomSummaryMaxActMinRevenueViewport(ChartViewport, chartGroups, chartCurve) {
  var chartParams = require('./RomSummaryLineGraphViewportParams');
  var chartScales = require('./RomSummaryLineGraphScales');
  var Chart = function Chart(container) {
    // chart components
    var groups = chartGroups('dimension', undefined, false);
    var curves = chartCurve('dimension', 'value', 'curveData').discontinuous(true);
    ChartViewport.call(this, container, chartParams, chartScales, groups, curves);
    this.initChart = function (data, xRange, params) {
      this.data = data || this.data;
      this.visibleXRange = xRange || this.visibleXRange || [0, data[0].curveData.length];
      this.params = params(this.container.width(), this.container.height());
      this.translateChart();
    };
    this._resetBrush = this.resetBrush;
    this.resetBrush = function () {
      this._resetBrush.apply(this, arguments);
    };
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
RomSummaryMaxActMinRevenueViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsCurves'];
module.exports = RomSummaryMaxActMinRevenueViewport;